module.exports = __webpack_public_path__ + "static/media/PhilippStudybear.a2e858fa.jpg";